var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECT",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m300.12 117.66a7.54 7.54 0 0 1 7.47 0l184.41 105.77v-38.82a7.51 7.51 0 0 0 -3.77-6.51l-180.64-103.61a7.54 7.54 0 0 0 -7.47 0l-129 74h75.27z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m119.81 245.45-4.44 12.21h8.88z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m22.5 338.5h250a22.52 22.52 0 0 0 22.5-22.5v-130a22.52 22.52 0 0 0 -22.5-22.5h-250a22.52 22.52 0 0 0 -22.5 22.5v130a22.52 22.52 0 0 0 22.5 22.5zm183.06-115a7.5 7.5 0 0 1 7.5-7.5h35a7.5 7.5 0 0 1 0 15h-27.5v12.5h27.5a7.5 7.5 0 0 1 0 15h-27.5v12.5h27.5a7.5 7.5 0 0 1 0 15h-35a7.5 7.5 0 0 1 -7.5-7.5zm-55.37 0a7.5 7.5 0 0 1 15 0v47.5h27.5a7.5 7.5 0 0 1 0 15h-35a7.5 7.5 0 0 1 -7.5-7.5zm-57.43 52.44 20-55a7.5 7.5 0 0 1 14.1 0l20 55a7.5 7.5 0 0 1 -14.1 5.12l-3-8.4h-19.84l-3.06 8.4a7.5 7.5 0 1 1 -14.1-5.12zm-23.85-17.11h-8.91c-11.32 0-20.53-9.45-20.53-21.08v-.67c-.03-11.62 9.18-21.08 20.53-21.08h22a7.5 7.5 0 0 1 0 15h-22a5.83 5.83 0 0 0 -5.53 6.08v.67a5.83 5.83 0 0 0 5.53 6.08h8.94c11.32 0 20.53 9.46 20.53 21.09s-9.24 21.08-20.56 21.08h-22a7.5 7.5 0 0 1 0-15h22a6.11 6.11 0 0 0 0-12.17z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m504.5 423.5h-329.68l.18-70h-55l-.18 70h-112.32a7.5 7.5 0 0 0 0 15h497a7.5 7.5 0 0 0 0-15z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m190 353.5h55.55v55h-55.55z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m461.89 408.5v-185l-158-90.64-27.66 15.87a37.56 37.56 0 0 1 33.77 37.27v87h44.66a7.5 7.5 0 0 1 7.5 7.5v128z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m310 316a37.54 37.54 0 0 1 -37.5 37.5h-11.95v55h86.61v-120.5h-37.16zm14.58 26.61a7.5 7.5 0 0 1 15 0v11.29a7.5 7.5 0 0 1 -15 0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSale);
export default __webpack_public_path__ + "static/media/sale.d2e23b7541c8ac60dfa9b2424b966b5a.svg";
export { ForwardRef as ReactComponent };